import { queryKeys } from '@/lib/query-keys';
import { phonePlanClient } from '@/lib/api/ts-rest';
import type { PhonePlan } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';

export function usePhonePlansByOrganizationId(
  organizationId: string | undefined
) {
  return useQuery({
    queryKey: queryKeys.catalog.phonePlansByOrganization(organizationId),
    queryFn: async () => {
      const res = await phonePlanClient.listPhonePlans({
        params: { organizationId: organizationId! },
        query: {},
      });
      if (res.status !== 200) throw new Error('Failed to load plans');
      return res.body;
    },
    enabled: !!organizationId,
  });
}

export const usePhonePlansAvailableToChange = (
  planId: string | undefined,
  organizationId: string | undefined
) => {
  return useQuery<PhonePlan[], Error>({
    queryKey: queryKeys.catalog.plansAvailableToChange(planId, organizationId),
    queryFn: async () => {
      const res = await phonePlanClient.listPhonePlans({
        params: { organizationId: organizationId! },
        query: { changeableFrom: planId! },
      });
      if (res.status !== 200) throw new Error('Failed to load plans');
      return res.body;
    },
    enabled: !!planId && !!organizationId,
  });
};
